declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

const CLARITY_PROJECT_ID = "x6fdyehu9e";

export const initClarity = () => {
  if (import.meta.env.VITE_APP_PHASE !== "production") {
    return;
  }

  if (window.clarity) {
    return;
  }

  window.clarity = function (...args: unknown[]) {
    (window.clarity!.q = window.clarity!.q || []).push(args);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
};
